<template>
    <div class="content">
        <waybill-header :showSearch="false" :isBillSearch="true" />
        <p class="search-tip">{{ _ll('请输入想要查询的运单号') }}</p>
        <div class="waybill-search">
            <div v-for="(num, index) in inputtedArr" v-show="showInputted" :key="num" class="inputted">
                <input type="text" name="valueList" :value="num" size="15" :class="{ hideBorderBottom: index === 9 }" readonly />
                <span class="close" @click="deleteNO(num)"></span>
            </div>
            <div class="input-wrapper">
                <input
                    v-show="!disabledInput"
                    v-model="searchBillNumber"
                    type="text"
                    class="search-input"
                    :placeholder="placeholderText"
                    :disabled="disabledInput"
                    @input="handleInputEvent"
                />
                <p v-show="inputFocus" class="del-inputting" @click="deleteInputting">
                    <icon name="input-delete"></icon>
                </p>
            </div>
        </div>
        <div class="separator"></div>
        <div class="history">
            <p>{{ _ll('查询历史') }}</p>
            <p class="del-history" @click="deleteSearchHistory">
                <icon name="delete"></icon>
            </p>
            <ul class="bill-list">
                <li v-for="billNO in historyBillNumbers" :key="billNO" @click="pushInputtedArr(billNO)">{{ billNO }}</li>
            </ul>
        </div>
        <div class="search-btn" :class="disabledBtn ? 'disable' : ''" @click="!disabledBtn && queryBill()">
            <icon name="to-right"></icon>
        </div>
    </div>
</template>

<script>
import WaybillHeader from './waybill-header'
import { verifyBillNumber } from '../../util/util'
import ajax from '../../api/ajax'
import { getNearbyWaybillNo, deleteNearbyWaybillNo } from '../../util/waybillUtils'
export default {
    name: 'WaybillSearch',
    components: {
        WaybillHeader
    },
    data() {
        return {
            inputtedArr: [], // 暂时存放用户已输入的运单号
            searchBillNumber: '', // 用户输入的运单号
            historyBillNumbers: getNearbyWaybillNo(), /// /查询历史的运单号
            disabledBtn: true,
            disabledInput: false,
            placeholderText: '',
            showModalCaptcha: false,
            inputFocus: false // 输入框的删除按钮
        }
    },
    computed: {
        // 是否显示已输入的运单号
        showInputted() {
            return this.inputtedArr.length > 0
        }
    },
    beforeMount() {
        this.$store.commit('setTitle', this._ll('运单追踪'))
        this.$store.commit('setShowHeader', false) // 隐藏公共的头部
    },
    mounted() {
        setTimeout(function () {
            document.getElementsByClassName('waybill-search')[0].scrollTop = document.getElementsByClassName('waybill-search')[0].scrollHeight
        }, 300)
    },
    methods: {
        /**
         * 处理输入事件
         */
        handleInputEvent: function () {
            this.searchBillNumber = this.searchBillNumber.replace(/\s/g, '') // 去空格
            if (this.searchBillNumber.length === 0) {
                this.inputFocus = false
                this.inputtedArr.length === 0 ? (this.disabledBtn = true) : (this.disabledBtn = false)
            } else {
                this.inputFocus = true
                this.disabledBtn = true
            }
            if (this.searchBillNumber.length === 12 || this.searchBillNumber.length === 15) {
                // 运单号校验
                if (/^(SF)[0-9]{10}$/.test(this.searchBillNumber.toUpperCase())) {
                    return
                }
                if (verifyBillNumber(this.searchBillNumber.toUpperCase())) {
                    this.handleBillNumber()
                } else {
                    this.$toast('运单号输入有误')
                }
            }
        },
        /**
         * 	正确运单号处理
         */
        handleBillNumber() {
            this.disabledBtn = false
            if (!this.inputtedArr.find(val => val === this.searchBillNumber.toUpperCase())) {
                this.inputtedArr.push(this.searchBillNumber.toUpperCase())
            } else {
                this.$toast('运单号不能重复')
            }
            this.searchBillNumber = ''
            this.inputFocus = false
            if (this.inputtedArr.length > 0) {
                this.disabledInput = true
            }
        },
        /**
         * 删除单号
         */
        deleteNO(billNO) {
            this.inputtedArr.splice(
                this.inputtedArr.findIndex(obj => obj === billNO),
                1
            )
            if (this.inputtedArr.length === 0) {
                this.disabledBtn = true
            }
            this.disabledInput = false
            if (this.inputtedArr.length === 9) {
                this.searchBillNumber = ''
            }
        },
        /**
         * 根据运单号查询路由
         */
        queryWaybillByBillNO() {
            const that = this

            // axios.head('/log?billnumber=' + that.inputtedArr.join(','));
            // eslint-disable-next-line no-undef
            if (_webconfig.useTencentCaptcha == true) {
                ajax.getTencentUrl({
                    params: { device: 'mobile' }
                }).then(response => {
                    if (response.data) {
                        const scriptDom = document.createElement('script')
                        scriptDom.src = response.data.result
                        scriptDom.type = 'text/javascript'
                        document.body.appendChild(scriptDom)
                        scriptDom.onreadystatechange = function () {
                            // eslint-disable-next-line no-undef
                            capDestroy()
                            const capOption = {
                                callback: function (retJson) {
                                    if (retJson.ret === 0) {
                                        that.queryBill(that, retJson.ticket, true)
                                    }
                                },
                                showHeader: true,
                                themeColor: '000000',
                                type: 'popup',
                                end: function () {
                                    that.showModalCaptcha = false
                                }
                            }
                            that.showModalCaptcha = true
                            // eslint-disable-next-line no-undef
                            capInit(document.getElementById('TCaptcha'), capOption)
                        }
                        scriptDom.onload = function () {
                            // eslint-disable-next-line no-undef
                            capDestroy()
                            const capOption = {
                                callback: function (retJson) {
                                    if (retJson.ret === 0) {
                                        that.queryBill(that, retJson.ticket, true)
                                    }
                                },
                                showHeader: true,
                                themeColor: '000000',
                                pos: 'fixed',
                                type: 'popup',
                                end: function () {
                                    that.showModalCaptcha = false
                                }
                            }
                            that.showModalCaptcha = true
                            // eslint-disable-next-line no-undef
                            capInit(document.getElementById('TCaptcha'), capOption)
                        }
                    }
                })
            } else {
                this.queryBill(this, null, true)
            }
        },
        /**
         * 跳转到路由页面
         * @param that
         * @param ticket
         * @param isGrayscaleUser
         */
        queryBill(that, ticket, isGrayscaleUser) {
            this.$router.push({ name: 'WaybillDetail', params: { bno: this.inputtedArr.join(',') } })
        },
        /**
         * 单击历史单号时将历史单号放入已输入的单号数组中
         * @param billNO
         */
        pushInputtedArr(billNO) {
            if (this.inputtedArr.includes(billNO)) {
                this.$toast('运单号不能重复')
            } else {
                if (this.inputtedArr.length < 1) {
                    this.inputtedArr.push(billNO)
                }
                if (this.inputtedArr.length > 0) {
                    this.disabledInput = true
                }
                if (this.inputtedArr.length > 0 && !this.searchBillNumber) {
                    this.disabledBtn = false
                }
            }
        },
        /**
         * 	删除当前输入内容
         */
        deleteInputting() {
            this.searchBillNumber = ''
            this.inputFocus = false
            this.inputtedArr.length === 0 ? (this.disabledBtn = true) : (this.disabledBtn = false)
        },
        /**
         *  删除查询历史记录
         */
        deleteSearchHistory() {
            // eslint-disable-next-line no-undef
            this.$confirm(_ll('是否删除历史记录？')).then(() => {
                this.historyBillNumbers = ''
                deleteNearbyWaybillNo()
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.content {
    background: #fff;
    min-height: 50%;
    input:not([readonly]) {
        padding: 0.2rem 0.5rem;
        border: 1px solid transparent;
    }
    .input:focus {
        border: 0;
    }
    .search-tip {
        font-size: 0.25rem;
        color: #999;
        padding: 0.2rem 0.5rem 0;
    }
    .waybill-search {
        background: #fff;
        max-height: 350px;
        overflow: scroll;
        -webkit-overflow-scrolling: touch;
        .inputted {
            color: #333;
            padding: 0 0.4rem;
            border-radius: 0.3em;
            -webkit-border-radius: 0.3em;
            position: relative;
            z-index: 0;
            white-space: nowrap;
            margin: 0 13px 10px;
            input {
                overflow: hidden;
                border-bottom: none;
            }
            .hideBorderBottom {
                border-bottom: 0;
                &:focus {
                    border-bottom: 0;
                }
            }
            .close {
                position: absolute;
                right: 0.6rem;
                display: inline-block;
                &:after {
                    content: '×';
                    display: inline-block;
                    width: 0.2rem;
                    font-size: 0.6rem;
                    color: #818181;
                    cursor: pointer;
                }
            }
        }
        .input-wrapper {
            position: relative;
            .search-input {
                &:focus {
                    border-bottom: 0.01rem solid transparent;
                }
            }
            .del-inputting {
                width: 0.34rem;
                position: absolute;
                bottom: 0.2rem;
                right: 0.6rem;
            }
        }
    }
    .separator {
        border-bottom: 0.02rem solid $red;
        margin-top: 0.05rem;
    }
    .history {
        padding: 0.5rem 0.4rem;
        position: relative;
        p {
            color: #999;
            font-size: 0.3rem;
            padding: 0 0.5rem;
        }
        .del-history {
            width: 0.4rem;
            height: 0.4rem;
            position: absolute;
            top: 0.4rem;
            right: 0.9rem;
        }
        .bill-list {
            padding: 0 0.5rem;
            li {
                height: 1rem;
                line-height: 1rem;
                border-bottom: 1px solid $gray-light;
                font-size: 0.28rem;
            }
        }
    }
    .search-btn {
        position: absolute;
        top: 6rem;
        right: 1rem;
        width: 1.2rem;
        height: 1.2rem;
        border-radius: 0.6rem;
        color: $white;
        background-color: $red;
        padding: 0.38rem;
        z-index: 10;
    }
    .search-btn.disable {
        background-color: $gray-light;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/waybill/waybill-search.vue